export const fetchWithAuthInterceptor = async (url, options = {}) => {
  try {
    const response = await fetch(url, options);

    if (response.status === 401) {
      console.error("Unauthorized access - logging out...");
      let tempCode = localStorage.getItem("TempCode");
      if (!tempCode) {
        localStorage.clear();
      }
      window.location.href = window.location.origin + window.location.pathname;
      return;
    }

    return response;
  } catch (error) {
    console.error("Error during fetch:", error);
    if (error.name !== "AbortError") {
      console.error("Error during fetch:", error);
    }
    throw error;
  }
};